"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BubbleHoverTrigger = exports.HIDE_DELAY = exports.SHOW_DELAY = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var BubbleTrigger_1 = require("./BubbleTrigger");
exports.SHOW_DELAY = 425;
exports.HIDE_DELAY = 200;
/**
 * @internal
 */
var BubbleHoverTrigger = /** @class */ (function (_super) {
    tslib_1.__extends(BubbleHoverTrigger, _super);
    function BubbleHoverTrigger() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BubbleHoverTrigger.prototype.componentWillUnmount = function () {
        this.cancelBubbleVisibilityChange();
    };
    BubbleHoverTrigger.prototype.cancelBubbleVisibilityChange = function () {
        if (this.scheduleId) {
            window.clearTimeout(this.scheduleId);
        }
    };
    BubbleHoverTrigger.prototype.scheduleBubbleVisibilityChange = function (visible, delay) {
        var _this = this;
        if (delay === void 0) { delay = 0; }
        this.cancelBubbleVisibilityChange();
        this.scheduleId = window.setTimeout(function () {
            _this.changeBubbleVisibility(visible);
            var hoverHideDelay = _this.props.hoverHideDelay;
            if (visible && hoverHideDelay) {
                _this.scheduleBubbleVisibilityChange(false, hoverHideDelay);
            }
        }, delay);
    };
    BubbleHoverTrigger.prototype.eventListeners = function () {
        return {
            onMouseEnter: this.scheduleBubbleVisibilityChange.bind(this, true, this.props.showDelay),
            onMouseLeave: this.scheduleBubbleVisibilityChange.bind(this, false, this.props.hideDelay),
        };
    };
    BubbleHoverTrigger.defaultProps = {
        showDelay: exports.SHOW_DELAY,
        hideDelay: exports.HIDE_DELAY,
        hoverHideDelay: 0,
        eventsOnBubble: false,
        tagName: "span",
    };
    return BubbleHoverTrigger;
}(BubbleTrigger_1.BubbleTrigger));
exports.BubbleHoverTrigger = BubbleHoverTrigger;
//# sourceMappingURL=BubbleHoverTrigger.js.map